export enum PatientRoute {
  Questions = "questions",
  Welcome = "welcome",
  Start = "start",
  TermsOfService = "termsofservice",
  Result = "result",
  Disclaimer = "disclaimer",
  Summary = "summary",
  Thanks = "thanks",
  MoreInfo = "moreInfo",
  Profile = "profile",
}
export const PatientRoute_Default = PatientRoute.Welcome;
